import { get } from 'svelte/store';

import { api } from '../../../../stores/api';
import type { IVehicleOnMap } from './VehiclesOnMap';
import { Navigation } from '../../../utilities/Navigation';
import { scenarioManager } from '../../../../stores/store';
import type { VehicleTypeType } from '../../Vehicles/Vehicle';
import { FriendlyDateGenerator } from '../../../utilities/FriendlyDateGenerator';

// import svgIconNextJobPoint from '../../../../assets/radio_button_checked_FILL0_wght400_GRAD0_opsz24.svg';

export class PointOnMap {
    private mapObj: any = null;
    private randomName: string = 'last_position_point_' + Math.random().toString(36).substring(7);

    public removePoint() {
        if (this.mapObj && this.mapObj?.id) {
            Targeo.Base.Map.UORemove(this.mapObj.id);
        }
    }

    public drawPointAsNextJob(x: number, y: number) {
        this.removePoint();
        let zIndex = 502 + 90 - y;
        let w = 30;
        let h = 30;
        let xx = w / 2 - 1;
        let yy = h - 15;
        this.mapObj = new Targeo.MapObject.Point(
            { x, y },
            {
                imageUrl:
                    'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMC42MDgiIGhlaWdodD0iMTMuODgzIiB2aWV3Qm94PSIwIDAgMjAuNjA4IDEzLjg4MyI+PHBhdGggZD0iTTIuNjM2LDEyLjI0M2wtLjY1MS0xLjNINi41NDFMNi4wMiw5LjY0SDEuNzY4bC0uNjUxLTEuM0g3Ljg4NmwtLjUyMS0xLjNIMUwuMjUsNS43MzVIMy41QTEuNzM1LDEuNzM1LDAsMCwxLDUuMjM5LDRIMTUuNjUyVjcuNDcxaDIuNmwyLjYsMy40NzFWMTUuMjhIMTkuMTIyYTIuNiwyLjYsMCwwLDEtNS4yMDYsMEgxMC40NDVhMi42LDIuNiwwLDEsMS01LjIwNiwwSDMuNVYxMi4yNDNabTEzLjg4Myw0LjMzOGExLjMsMS4zLDAsMSwwLTEuMy0xLjMsMS4zLDEuMywwLDAsMCwxLjMsMS4zbTEuMy03LjgwOUgxNS42NTJ2Mi4xNjloMy44N1pNNy44NDIsMTYuNTgyYTEuMywxLjMsMCwxLDAtMS4zLTEuMywxLjMsMS4zLDAsMCwwLDEuMywxLjMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0wLjI1IC00KSIvPjwvc3ZnPg==',
                w,
                h,
                coordsAnchor: { x: xx, y: yy },
                x: xx,
                y: yy,
            },
            this.randomName + '_next_job',
            {
                name: '_next_job',
                zIndex,
                visible: true,
                balloon: {
                    body: '<div class="">Następny punkt na trasie</div>',
                },
                mouseButtonActions: {
                    left: () => {
                        console.log('left click');
                    },
                },
            }
        );

        Targeo.Base.Map.UOAdd(this.mapObj);
    }

    public drawPoint(
        x: number,
        y: number,
        ts: string,
        color: string,
        opacity: number,
        position: IVehicleOnMap,
        parking: boolean = false
    ) {
        let name = position.vehicle.getName();
        let type: VehicleTypeType = position.vehicle.getType();
        this.createPoint(
            x,
            y,
            ts,
            name,
            color,
            opacity,
            true,
            { type: 'delivery' },
            position,
            type,
            parking
        );
    }

    public static getIconUrl(
        color: string,
        opacity: number,
        w: number,
        h: number,
        type: VehicleTypeType,
        pureicon: boolean = false,
        parking: boolean = false
    ) {
        let baseUrl = get(api).getApiUrl();
        return (
            baseUrl +
            `/icons/vehicle?c=${color.replace('#', '')}&parking=${parking ? '1' : '0'}&t=${type}&w=${w}&h=${h}&pureicon=${pureicon}&o=${opacity}`
        );
    }

    private createPoint(
        x: number,
        y: number,
        ts: string,
        name: string,
        color: string,
        opacity: number,
        visible: boolean,
        pinOpts: any,
        position: IVehicleOnMap,
        type: VehicleTypeType,
        parking: boolean = false
    ) {
        this.removePoint();
        let zIndex = 502 + 90 - y;
        let w = 40;
        let h = 60;
        let xx = w / 2 - 1;
        let yy = h - 10;
        let imageUrl = PointOnMap.getIconUrl(color, opacity, w, h, type, false, parking);
        // let imageUrl = baseUrl + `/icons/vehicle?c=${color.replace('#','')}&parking=${is_parking}&t=${type}&w=${w}&h=${h}`;
        // console.log('vehiclesOnMap, imageUrl', imageUrl);
        this.mapObj = new Targeo.MapObject.Point(
            { x, y },
            {
                imageUrl,
                w,
                h,
                coordsAnchor: { x: xx, y: yy },
                x: xx,
                y: yy,
            },
            this.randomName,
            {
                name,
                zIndex,
                visible,
                balloon: {
                    body:
                        '<div class="">' +
                        name +
                        '<br>Ostatni sygnał: ' +
                        FriendlyDateGenerator.getTimeDiffString(new Date(ts)) +
                        ' (' +
                        (ts || 'brak') +
                        ')' +
                        '</div>',
                },
                mouseButtonActions: {
                    left: () => {
                        console.log('left click');
                        Navigation.navigate(
                            `/planning/${get(scenarioManager).getAssignmentIdByVehicleId(position.vehicle.getId())}`
                        );
                    },
                },
                // fGetContextMenu: this.jobContextMenu.bind(this),
                // cluster: getJobCluster(color, job.filter === false ? JobsOnMap.pinSizes.unmatching : (job.filter === true ? JobsOnMap.pinSizes.matching : JobsOnMap.pinSizes.normal), Object.assign(pinOpts, {type: job.doc}), get(clientSettings).display.icon_style),
            }
        );
        // this.mapObj = new Targeo.MapObject.Point(
        //     {x, y},
        //     transmitter.getIcon(color),
        //     this.randomName,
        //     {
        //         name: '',
        //         zIndex: zIndex,
        //         draggable: false,
        //         // balloon: { body: transmitter.getVehicleTable() },
        //         interactive: true,
        //         visible: true,
        //         spread: false, //
        //         rotation: transmitter.getDirectionRadians(),
        //         mouseButtonActions: {
        //             left: () => {
        //                 console.log('Clicked vehicle LEFT ');
        //                 if (typeof callbackOnLeftClick === 'function') {
        //                     callbackOnLeftClick(transmitter);
        //                 }
        //                 // Mapa.zoomAndCenter(coords, 14, true);
        //             },
        //             right: () => {
        //                 console.log('Clicked vehicle RIGHT ');
        //                 if (typeof callbackOnRightClick === 'function') {
        //                     callbackOnRightClick(transmitter);
        //                 }
        //                 // Mapa.zoomAndCenter(coords, 14, true);
        //             }
        //         }
        //     },
        // );
        Targeo.Base.Map.UOAdd(this.mapObj);
    }
}
